export const FETCH_LATEST_APP_VERSION_START = 'FETCH_LATEST_APP_VERSION_START';
export const FETCH_LATEST_APP_VERSION_FAIL = 'FETCH_LATEST_APP_VERSION_FAIL';
export const FETCH_LATEST_APP_VERSION_SUCCESS = 'FETCH_LATEST_APP_VERSION_SUCCESS';

export const SEND_CONTACTS_REQUEST_START = 'SEND_CONTACTS_REQUEST_START';
export const SEND_CONTACTS_REQUEST_SUCCESS = 'SEND_CONTACTS_REQUEST_SUCCESS';
export const SEND_CONTACTS_REQUEST_FAILURE = 'SEND_CONTACTS_REQUEST_FAILURE';
